// extracted by mini-css-extract-plugin
module.exports = {"print":"Bill_print__3pdWC","tableHeader":"Bill_tableHeader__2cXSI"};